import Vue from "vue";
import VueRouer from "vue-router";

// 润达数据屏主屏
import rundadashboard from "views/runda/dashboard";

// 润达数据屏智慧追溯
import rundatrace from "views/runda/trace";

// 润达数据屏智慧种植
import rundaindustryInformation from "views/runda/industryInformation";

// 润达环控中心
import rundaenvironmentMonitor from "views/runda/environmentMonitor";

// 润达销售数据中心
import rundasalesDataCenter from "views/runda/salesDataCenter";
// 润达扶贫
import rundahelper from "views/runda/helper";
// 润达扶贫
import test from "views/runda/test";
// 测试

import lujiacun from "views/runda/lujiacun";
// 鲁家村

import tourupin from "views/runda/tourupin";
// 投入品

import yinxiao from "views/runda/yinxiao";
// 营销

import chaye from "views/runda/chaye";
// 茶叶

// 总屏(维度包含市，县)
import dashboard from "views/dashboard";
// 企业基地
import base from "views/base";
// 精准扶贫
import helpPoor from "views/helpPoor";
// 溯源信息
import trace from "views/trace";
// 环境监测
import environmentMonitor from "views/environmentMonitor";
// 产品展示
import product from "views/product";
// 产业信息
import industryInformation from "views/industryInformation";
// 视频监控
import video from "views/video";
// 备案信息
import recordInformation from "views/recordInformation";
// 子屏
import secondMap from "views/secondMap";

Vue.use(VueRouer);

const routes = [
  {
    path: "/",
    redirect: "/rundadashboard"
  },
  {
    path: "/chaye",
    component: chaye
  },
  {
    path: "/yinxiao",
    component: yinxiao
  },
  {
    path: "/test",
    component: test
  },
  {
    path: "/lujiacun",
    component: lujiacun
  },
  {
    path: "/tourupin",
    component: tourupin
  },
  {
    path: "/rundadashboard",
    component: rundadashboard
  },
  {
    path: "/rundatrace",
    component: rundatrace
  },
  {
    path: "/rundaindustryInformation",
    component: rundaindustryInformation
  },
  {
    path: "/rundaenvironmentMonitor",
    component: rundaenvironmentMonitor
  },
  {
    path: "/rundasalesDataCenter",
    component: rundasalesDataCenter
  },
  {
    path: "/rundahelper",
    component: rundahelper
  },
  {
    path: "/dashboard",
    component: dashboard
  },
  {
    path: "/base",
    component: base
  },
  {
    path: "/helpPoor",
    component: helpPoor
  },
  {
    path: "/trace",
    component: trace
  },
  {
    path: "/environmentMonitor",
    component: environmentMonitor
  },
  {
    path: "/product",
    component: product
  },
  {
    path: "/industryInformation",
    component: industryInformation
  },
  {
    path: "/video",
    component: video
  },
  {
    path: "/recordInformation",
    component: recordInformation
  },
  {
    path: "/secondMap",
    component: secondMap
  }
];
const router = new VueRouer({
  routes,
  linkActiveClass: "active"
});

router.afterEach((to, from) => {
  require("viewport-units-buggyfill").refresh();
});

// router.push('/rundaindustryInformation');
// router.push('/rundadashboard');
// router.push("/rundadashboard");
router.push("/chaye");

export default router;



// WEBPACK FOOTER //
// ./src/router.js